/**
=========================================================
* Soft UI Dashboard PRO React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Soft UI Dashboard PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

import AdminUserSetting from "pages/admin/users";
import AdminInvitation from "pages/admin/invite-code";
import AdminProjects from "pages/admin/projects";
import AdminMoodboards from "pages/admin/moodboards";
import AdminStyles from "pages/admin/styles";
import AdminCollections from "pages/admin/collections";

import AdminRequests from "pages/admin/requests";
import AdminProjectDetail from "pages/admin/projects/detail";
import AdminOnlineResource from "pages/admin/resource";

import NewPortfolioPage from "pages/de/new-portfolio";

import AdminPanelSettingsRoundedIcon from "@mui/icons-material/AdminPanelSettingsRounded";

import FashionLabPage from "pages/fashionlab";

const routes = [
  /*
  {
    type: "collapse",
    name: "Home",
    key: "/",
    component: <Home />,
    icon: <HomeIcon fontSize="small" />,
    route: "/",
    noCollapse: true,
  },
  */
  {
    name: "Admin",
    key: "a",
    type: "collapse",
    icon: <AdminPanelSettingsRoundedIcon fontSize="small" />,
    collapse: [
      {
        name: "Users",
        key: "users",
        route: "/a/users",
        component: <AdminUserSetting />,
      },
      {
        name: "Projects",
        key: "projects",
        route: "/a/projects",
        component: <AdminProjects />,
      },
      {
        name: "Moodboards",
        key: "Moodboards",
        route: "/a/moodboards",
        component: <AdminMoodboards />,
      },
      {
        name: "Styles",
        key: "styles",
        route: "/a/styles",
        component: <AdminStyles />,
      },
      {
        name: "Collections",
        key: "collections",
        route: "/a/collections",
        component: <AdminCollections />,
      },
      {
        name: "Requests",
        key: "requests",
        route: "/a/requests",
        component: <AdminRequests />,
      },
      {
        name: "Invite Codes",
        key: "invite-codes",
        route: "/a/invite-codes",
        component: <AdminInvitation />,
      },
      {
        name: "Online Resource",
        key: "online-resource",
        route: "/a/online-resource",
        component: <AdminOnlineResource />,
      },
    ],
  },
];

export default routes;
